<template>
    <div class="b-layout">
        <div class="b-container">
            <BNavbar />
            <router-view class="router-view" />
            <BTabbar />
        </div>
    </div>
</template>

<script>
import BNavbar from '../b-navbar/index.vue';
import BTabbar from '../b-tabbar/index.vue';
import { getStorage, px2rem } from '@/utils';

export default {
    components: {
        BNavbar,
        BTabbar
    },
    data() {
        return {
            deviceInfo: {}
        };
    },
    computed: {
        routerViewHeightStyle() {
            // const style = {
            //     height: '100%'
            // };
            // if (this.$route.meta.index === 0 && !this.$route.meta.hideNavBar) {
            //     style.height = `calc(100% - ${px2rem(96)})`;
            // } else if (this.$route.meta.index === 0 && this.$route.meta.hideNavBar) {
            //     style.height = `calc(100% - ${px2rem(50)})`;
            // } else if (this.$route.meta.index > 0 && !this.$route.meta.hideNavBar) {
            //     style.height = `calc(100% - ${px2rem(46)})`;
            // }
            return style;
        }
    },
    created() {
        console.log('🚀 ~ created ~ this.deviceInfo:', 'ccccccccccccccccccccccccc');
        this.deviceInfo = JSON.parse(getStorage('device-info') || '{}');
        console.log('🚀 ~ created ~ this.deviceInfo:', this.deviceInfo);
    }
};
</script>

<style lang="scss" scoped>

.b-layout {
    position: relative;
    overflow: hidden;
    max-width: 600px !important;
    display: flex;
    flex-direction: column;

    .b-container {
        position: relative;
        width: 100%;
        background-color: #eee;
        overflow: hidden;

        .router-view {
            position: absolute;
            width: 100%;
            height: 100%;
            background: #fff;
            overflow-y: auto;
        }
    }
}
</style>
